import {
    NEXT_NAVIGATION_STEP_ONE,
    NEXT_NAVIGATION_STEP_TWO,
    NEXT_NAVIGATION_STEP_TREE,
    NEXT_NAVIGATION_STEP_FOUR,
    PROGRESS_CHANGE_NO
} from './types';


export function StepOne() {
    return function (dispatch) {
        dispatch ({type:NEXT_NAVIGATION_STEP_ONE})
    }
}

export const StepTwo = () => {
    return {
        type: NEXT_NAVIGATION_STEP_TWO,
    };
};

export const StepTree = () => {
    return {
        type: NEXT_NAVIGATION_STEP_TREE,
    };
};


export const StepFour = () => {
    return {
        type: NEXT_NAVIGATION_STEP_FOUR,
    };
};




